import { robocall1 } from "../assets";
import { useState } from "react";
// import ContactForm from "./ContactForm";
import { featureList } from "../constants";
import Heading from "./Heading";
import TagLine from "./Tagline";
import { aiCallingServices } from "../constants";
import Section from "./Section";
import { Link } from "react-router-dom";
const Collaboration = () => {
  // const [showForm, setShowForm] = useState(false);

  // const openForm = () => setShowForm(true);
  // const closeForm = () => setShowForm(false);

  return (
    <Section crosses id="products">
      <div className="container">
        <Heading className="mb-24" title="Our Products" />
        <Heading
          className="md:max-w-md lg:max-w-2xl"
          title="AI CALLING AGENT"
          headingclassName="!text-4xl mb-3 text-[#B780EF]"
          tag="Redefining Conversations, One Call at a Time"
          tagclassName="!text-sm"
        />

        {/* Top Section: Left and Right Content */}
        <div className="mx-auto flex max-w-[45rem] flex-col gap-12 rounded-xl bg-neutral-950 neon-purple xl:max-w-[77rem] xl:flex-row">
          {/* Left Column: Image/Visual */}
          <div className="xl:w-1/2">
            <img
              src={robocall1}
              alt="AI Calling Agent"
              className="rounded-t-xl opacity-90 md:aspect-[16/11] lg:h-full lg:w-full xl:aspect-auto xl:rounded-s-xl xl:rounded-t-none xl:object-cover"
            />
          </div>

          {/* Right Column: Content */}
          <div className="w-full px-4 py-4 xl:w-1/2 xl:py-8 xl:pl-0">
            <h3 className="h7 text-center text-2xl font-bold text-white sm:text-3xl lg:text-4xl">
              Enhance Productivity with <br />
              <span className="text-[#B780EF]">AI-Driven Calls</span>
            </h3>
            <TagLine className="mt-4 flex justify-center text-center">
              Real Conversations, Powered by AI
            </TagLine>
            <p className="mt-6 text-left text-sm leading-loose text-n-2 sm:text-base">
              Transform your business communication with our AI Calling Agent.
              From customer service to lead generation and appointment
              scheduling, it handles key tasks with seamless, human-like
              interactions 24/7. This advanced AI technology enhances
              efficiency, improves customer satisfaction, and reduces
              operational costs, offering a more personalized and responsive
              experience for every call.
            </p>

            <div className="mt-6 flex flex-col space-y-4">
              {aiCallingServices.map((item, index) => (
                // <div className="flex items-center gap-4" key={index}>
                <span className="text-left text-sm text-n-2" key={index}>
                  {`➤ ${item}`}
                </span>
                // </div>
              ))}
            </div>
            <div className="mt-12 flex justify-center gap-4 xl:justify-start">
              <Link to="/ai-calling-agent">
                <button
                  // onClick={openForm}
                  className="rounded-lg bg-neutral-900 px-6 py-3 font-medium text-white shadow-md hover:bg-neutral-800"
                >
                  Explore More
                </button>
              </Link>
            </div>
          </div>
          {/* <ContactForm show={showForm} closeOverlay={closeForm} /> */}
        </div>

        {/* Bottom Section: Features List */}
        <div className="mt-12 grid grid-cols-1 gap-12 p-3 sm:grid-cols-2 min-[1100px]:grid-cols-3">
          {featureList.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center rounded-xl border border-white bg-n-8 p-4 neon-purple"
            >
              <div className="flex flex-col items-center justify-center p-2 text-[#B780EF]">
                <img
                  width="80px"
                  height="80px"
                  src={item.icon}
                  alt={item.title}
                />
                <span className="mb-3 mt-4 text-center text-lg">
                  {item.title}
                </span>
              </div>
              <p className="leading-relaxed text-slate-300">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Collaboration;
